import React, { Component } from 'react';
import PageLoader from '../Layouts/PageLoader';
import AuthApi from '../Services/Authapi';
import ls from "local-storage";
import { isLoginSessionExpired, clearClientAuthState, performSessionExpiryLogout, syncServerTime } from '../../utils/authSession';

class InitComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: true
        };
        this.getAuth();
    }

    async getAuth() {
        if (isLoginSessionExpired()) {
            await performSessionExpiryLogout();
            this.props.setAutUser({ authUser: false, authToken: false });
            this.props.history.push('/login');
            this.setState({ isLoading: false });
            return;
        }

        try {
            let checkLogin = await AuthApi.checkAuth();
            if (checkLogin && checkLogin.status !== false) {
                if (checkLogin.data?.server_date || checkLogin.server_date) {
                    syncServerTime(
                        checkLogin.data?.server_date || checkLogin.server_date,
                        checkLogin.data?.server_time || checkLogin.server_time,
                        checkLogin.data?.server_timestamp || checkLogin.server_timestamp
                    );
                }
                if (Array.isArray(checkLogin.data?.userAccess)) {
                    ls.set("userAccess", checkLogin.data.userAccess);
                }
                this.props.setAutUser({ authUser: checkLogin.data });
                // Redirect to dashboard if authenticated
                this.props.history.push('/dashboard');
            } else {
                this.props.setAutUser({ authUser: false, authToken: false });
                // Redirect to login if not authenticated
                this.props.history.push('/login');
            }
        } catch (error) {
            console.error('Auth check failed:', error);
            this.props.setAutUser({ authUser: false, authToken: false });
            // Redirect to login on error
            this.props.history.push('/login');
        } finally {
            this.setState({ isLoading: false });
        }
    }

    render() { 
        return <PageLoader />;
    }
}
export default InitComponent;
